import type { ReactNode } from 'react';

export const symbol_chat_paste_go_2: ReactNode = (
	<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 -960 960 960">
		<path
			fill="currentColor"
			d="M751-240H600q-12.75 0-21.37-8.68-8.63-8.67-8.63-21.5 0-12.82 8.63-21.32 8.62-8.5 21.37-8.5h151l-52-53q-9-9-9-21t9-21q9-9 21-9t21 9l104 104q9 9 9 21t-9 21L741-145q-9 9-21 9t-21-9q-9-9-9-21.5t9-21.5l52-52Zm-511 0-94 94q-7 7-16.5 3.46T120-156v-584q0-24.75 17.63-42.38Q155.25-800 180-800h520q24.75 0 42.38 17.62Q760-764.75 760-740v190q0 12.75-8.68 21.37-8.67 8.63-21.5 8.63-12.82 0-21.32-8.63-8.5-8.62-8.5-21.37v-190H180v440h270q12.75 0 21.38 8.68 8.62 8.67 8.62 21.5 0 12.82-8.62 21.32-8.63 8.5-21.38 8.5H240Zm-60-60v-440 440Z"
		/>
	</svg>
);
